export const IMAGE_EXTENSIONS = ['apng', 'avif', 'gif', 'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'png', 'svg', 'webp'];

export const isFileImage = (fileName: string): boolean => {
  const extension = fileName.split('.').pop();
  if (!extension) {
    return false;
  }

  return IMAGE_EXTENSIONS.includes(extension.toLowerCase());
};
